import Vue from 'vue'
import VueRouter from 'vue-router'

import mobileLayout from '@/mobileLayout'

// 路由拦截函数
import beforeEachFn from "./beforeEach"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/search/bottleInfo"
  },
  {
    path: '/flowPath',
    component: mobileLayout,
    redirect: '/flowPath/scanCode',
    children: [
      {
        path: "/flowPath/scanCode",
        component: () => import("@/views/flowPath/scanCode"),
        meta: {
          title: "扫码",
          index: 1
        }
      },
      {
        path: "/flowPath/batchScanCode",
        component: () => import("@/views/flowPath/batchScanCode"),
        meta: {
          title: "批量扫码",
          index: 2
        }
      },
      {
        path: "/flowPath/putOnRecord",
        component: () => import("@/views/flowPath/putOnRecord"),
        meta: {
          title: "钢瓶建档",
          index: 2
        }
      },
      {
        path: '/flowPath/index',
        component: () => import('@/views/flowPath/index'),
        meta: {
          title: "流转流程",
          index: 2
        }
      },
      {
        path: '/flowPath/collect',
        component: () => import('@/views/flowPath/collect'),
        meta: {
          title: "提交流程",
          index: 3
        }
      },
      {
        path: '/flowPath/collectNew',
        component: () => import('@/views/flowPath/collectNew'),
        meta: {
          title: "提交流程",
          index: 4
        }
      },
      {
        path: '/flowPath/filling',
        component: () => import('@/views/flowPath/filling'),
        meta: {
          title: "充装",
          index: 4
        }
      }
    ],
  },
  {
    path: "/inviteFriends",
    component: mobileLayout,
    redirect: "/inviteFriends/myQrcode",
    children: [
      {
        path: "/inviteFriends/promotionAward",
        meta: {
          title: "推广奖励",
          index: 1
        },
        component: () => import('@/views/inviteFriends/promotionAward'),
      },
      {
        path: "/inviteFriends/myQrcode",
        meta: {
          title: "邀请好友",
          index: 2
        },
        component: () => import('@/views/inviteFriends/myQrcode'),
      },
      {
        path: "/inviteFriends/myAchievement",
        meta: {
          title: "拓客业绩",
          index: 3
        },
        component: () => import('@/views/inviteFriends/myAchievement'),
      }
    ]
  },
  {
    path: "/search",
    component: mobileLayout,
    redirect: "/search/bottleInfo",
    children: [
      {
        path: "/search/bottleInfo",
        meta: {
          title: "钢瓶流转",
          index: 1
        },
        component: () => import('@/views/search/bottleInfo'),
      }
    ]
  },
  {
    path: "/flowMaterial/:bottleId",
    component: mobileLayout,
    meta: {
      title: "钢瓶流转",
      index: 1
    },
    component: () => import('@/views/search/partsInfo'),
  },
  {
    path: "/pubile",
    component: mobileLayout,
    redirect: "/pubile/afterSales",
    children: [
      {
        path: "/pubile/afterSales",
        meta: {
          title: "售后处理",
          index: 1,
          noAnimation: true
        },
        component: () => import('@/views/pubile/afterSales'),
      }
    ]
  },
  {
    path: "/deliveryClerk",
    component: mobileLayout,
    redirect: "/deliveryClerk/costStatistics",
    children: [
      {
        path: "/deliveryClerk/costStatistics",
        meta: {
          title: "配送费统计",
          index: 1,
          noAnimation: true
        },
        component: () => import('@/views/deliveryClerk/costStatistics'),
      }
    ]

  },
  {
    path: "/gasCer",
    component: mobileLayout,
    redirect: "/gasCer/detail",
    children: [
      {
        path: "/gasCer/detail",
        meta: {
          title: "电子合格证",
          index: 1
        },
        component: () => import('@/views/gasCer/detail'),
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach(beforeEachFn)

export default router
